/**
 * Size Guide Modal & Tab Functionality
 */

class SizeGuideModal {
    constructor() {
      this.modal = document.getElementById('SizeGuideModal');
      if (!this.modal) return;
  
      this.closeBtn = this.modal.querySelector('#ModalClose-SizeGuide');
      this.tabs = this.modal.querySelectorAll('.size-guide-tabs__tab');
      this.panels = this.modal.querySelectorAll('.size-guide-tabs__panel');
      this.scrollbarWidth = this.getScrollbarWidth();
  
      this.init();
    }
  
    init() {
      // Tab click events
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => this.handleTabClick(e));
      });
  
      // Close button click
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.hide());
      }
  
      // Click outside to close
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) {
          this.hide();
        }
      });
  
      // ESC key to close
      document.addEventListener('keyup', (e) => {
        if ((e.key === 'Escape' || e.code === 'Escape') && this.modal.hasAttribute('open')) {
          this.hide();
        }
      });
  
      // Watch for open attribute changes (when modal-opener triggers)
      this.observeModalState();
  
      // Initialize drag-to-scroll for tabs navigation
      this.initTabsDragScroll();
    }
  
    initTabsDragScroll() {
      const tabsNav = this.modal.querySelector('.size-guide-tabs__nav');
      if (!tabsNav) return;
  
      let isDown = false;
      let startX;
      let scrollLeft;
  
      tabsNav.addEventListener('mousedown', (e) => {
        isDown = true;
        tabsNav.style.cursor = 'grabbing';
        startX = e.pageX - tabsNav.offsetLeft;
        scrollLeft = tabsNav.scrollLeft;
      });
  
      tabsNav.addEventListener('mouseleave', () => {
        isDown = false;
        tabsNav.style.cursor = 'grab';
      });
  
      tabsNav.addEventListener('mouseup', () => {
        isDown = false;
        tabsNav.style.cursor = 'grab';
      });
  
      tabsNav.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - tabsNav.offsetLeft;
        const walk = (x - startX) * 1.5;
        tabsNav.scrollLeft = scrollLeft - walk;
      });
  
      // Set initial cursor
      tabsNav.style.cursor = 'grab';
    }
  
    observeModalState() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'open') {
            if (this.modal.hasAttribute('open')) {
              this.onOpen();
            } else {
              this.onClose();
            }
          }
        });
      });
  
      observer.observe(this.modal, { attributes: true });
    }
  
    getScrollbarWidth() {
      // Create a temporary div to measure scrollbar width
      const outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll';
      outer.style.msOverflowStyle = 'scrollbar';
      document.body.appendChild(outer);
  
      const inner = document.createElement('div');
      outer.appendChild(inner);
  
      const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
      outer.parentNode.removeChild(outer);
  
      return scrollbarWidth;
    }
  
    hasScrollbar() {
      return document.documentElement.scrollHeight > document.documentElement.clientHeight;
    }
  
    onOpen() {
      // Add class to body for modal open state
      document.body.classList.add('size-guide-modal-open');
  
      // Add padding only to body to prevent layout shift when scrollbar disappears
      if (this.hasScrollbar()) {
        document.body.style.paddingRight = `${this.scrollbarWidth}px`;
      }
  
      // Lock body scroll on both html and body
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }
  
    onClose() {
      // Remove class from body
      document.body.classList.remove('size-guide-modal-open');
  
      // Remove padding from body
      document.body.style.paddingRight = '';
  
      // Unlock body scroll
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  
    hide() {
      this.modal.removeAttribute('open');
      this.onClose();
    }
  
    handleTabClick(e) {
      const clickedTab = e.currentTarget;
      const tabKey = clickedTab.dataset.tab;
  
      // Remove active class from all tabs
      this.tabs.forEach((tab) => tab.classList.remove('active'));
  
      // Remove active class from all panels
      this.panels.forEach((panel) => panel.classList.remove('active'));
  
      // Add active class to clicked tab
      clickedTab.classList.add('active');
  
      // Add active class to corresponding panel
      const activePanel = this.modal.querySelector(`[data-panel="${tabKey}"]`);
      if (activePanel) {
        activePanel.classList.add('active');
      }
    }
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new SizeGuideModal());
  } else {
    new SizeGuideModal();
  }